var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"navbar-item",attrs:{"exact-active-class":"is-active","to":_vm.item.path}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }